import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useTransition, animated } from '@react-spring/web';
import classNames from 'classnames/bind';
import styles from './styles.scss';

const cx = classNames.bind(styles);

const BottomDrawer = forwardRef(({
  isOpen, children, className, unmountOnClose,
}, ref) => {
  const transition = useTransition(isOpen, {
    from: { bottom: '-100%' },
    enter: { bottom: '0%' },
    leave: { bottom: '-100%' },
    expires: unmountOnClose,
  });

  return transition(
    (style, item) => item && (
      <animated.div ref={ref} className={cx('drawer', className)} style={style}>
        {children}
      </animated.div>
    )
  );
});
export default BottomDrawer;
BottomDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  className: PropTypes.string,
  unmountOnClose: PropTypes.bool,
};
BottomDrawer.defaultProps = {
  className: null,
  unmountOnClose: false,
};
